// src/utils/loadCustomScripts.js
// Utility to load dependencies and custom JavaScript files in proper order

// Function to load Owl Carousel after jQuery is ready
async function loadOwlCarousel() {
  return new Promise((resolve, reject) => {
    // Verify jQuery is available and has fn property
    if (typeof window.$ === 'undefined' || typeof window.$.fn === 'undefined') {
      reject(new Error('jQuery or jQuery.fn is not available'))
      return
    }

    // Dynamically import Owl Carousel
    import('owl.carousel')
      .then(() => {
        console.log('✅ Owl Carousel loaded successfully')
        resolve()
      })
      .catch((err) => {
        console.error('❌ Failed to load Owl Carousel:', err)
        reject(err)
      })
  })
}

// Function to load custom scripts
function loadScripts(scripts) {
  return new Promise((resolve, reject) => {
    let loadedCount = 0
    const totalScripts = scripts.length

    if (totalScripts === 0) {
      resolve()
      return
    }

    function onScriptLoad() {
      loadedCount++
      if (loadedCount === totalScripts) {
        resolve()
      }
    }

    function onScriptError(src) {
      console.error(`Failed to load script: ${src}`)
      reject(new Error(`Failed to load script: ${src}`))
    }

    scripts.forEach((src) => {
      const script = document.createElement('script')
      script.src = src
      script.async = false // Maintain execution order

      script.onload = onScriptLoad
      script.onerror = () => onScriptError(src)

      document.body.appendChild(script)
    })
  })
}

// Function to verify Bootstrap is available
function verifyBootstrap() {
  return new Promise((resolve, reject) => {
    // Check if Bootstrap is available
    if (typeof window.bootstrap === 'undefined') {
      reject(new Error('Bootstrap is not available'))
      return
    }

    // Check if jQuery Bootstrap plugins are available
    if (typeof window.$.fn.carousel === 'undefined' || typeof window.$.fn.modal === 'undefined') {
      reject(new Error('Bootstrap jQuery plugins are not available'))
      return
    }

    console.log('✅ Bootstrap is ready')
    resolve()
  })
}

export async function loadCustomScripts() {
  try {
    // Ensure jQuery is available
    if (typeof window.$ === 'undefined' || typeof window.jQuery === 'undefined') {
      throw new Error('jQuery is not available')
    }


    // Step 1: Verify Bootstrap is ready
    await verifyBootstrap()

    // Step 2: Load Owl Carousel after jQuery is ready
    await loadOwlCarousel()

    // Step 3: Load custom scripts
    const customScripts = [
      '/src/assets/js/calendar.js',
      '/src/assets/js/full-screen.min.js',
      '/src/assets/js/main.js',
    ]

    await loadScripts(customScripts)
    console.log('✅ All custom scripts loaded successfully')
  } catch (error) {
    console.error('❌ Error in loadCustomScripts:', error)
    throw error
  }
}

// Alternative function to load scripts with jQuery document ready
export function loadCustomScriptsWithReady() {
  if (typeof window.$ !== 'undefined') {
    window.$(document).ready(() => {
      loadCustomScripts()
        .then(() => console.log('Custom scripts loaded and jQuery ready'))
        .catch((err) => console.error('Error loading custom scripts:', err))
    })
  } else {
    console.error('jQuery not available for document ready')
  }
}
